<script lang="ts">
  import Button from './Button.svelte';
  
  export let message: string = 'No items found';
  export let description: string = '';
  export let actionLabel: string | null = null;
  export let onAction: (() => void) | null = null;
  export let icon: string | null = null;
</script>

<div class="empty-state">
  {#if icon}
    <div class="empty-icon" aria-hidden="true">
      {@html icon}
    </div>
  {:else}
    <svg class="empty-icon" viewBox="0 0 24 24" width="64" height="64" fill="none" stroke="#9ca3af" stroke-width="1.5" aria-hidden="true">
      <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
    </svg>
  {/if}
  
  <h3 class="empty-title">{message}</h3>
  
  {#if description}
    <p class="empty-description">{description}</p>
  {/if}
  
  {#if actionLabel && onAction}
    <div class="empty-action">
      <Button variant="primary" on:click={onAction}>
        {actionLabel}
      </Button>
    </div>
  {/if}
</div>

<style>
  .empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 4rem 2rem;
    text-align: center;
    min-height: 300px;
  }

  .empty-icon {
    width: 64px;
    height: 64px;
    margin-bottom: 1.5rem;
    opacity: 0.5;
  }

  .empty-title {
    font-size: 1.125rem;
    font-weight: 600;
    color: #111827;
    margin: 0 0 0.5rem 0;
  }

  .empty-description {
    font-size: 0.875rem;
    color: #6b7280;
    margin: 0 0 1.5rem 0;
    max-width: 400px;
  }

  .empty-action {
    margin-top: 1rem;
  }
</style>

